import React from 'react';
import styles from './FormFieldError.module.scss';

export default function FormFieldError({ children }) {
  return <span className={styles.error}>{children}</span>;
}
